import React, { MouseEvent } from "react";

import { RenderLeafProps } from "slate-react";

import parsePhoneNumber from "@mapmycustomers/shared/util/phone/parsePhoneNumber";

const displayElements = ({ attributes, children, leaf }: RenderLeafProps) => {
  if (leaf.decoration === "url") {
    children = (
      <a
        href={leaf.text}
        onClick={(e: MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          window.open(leaf.text.startsWith("http") ? leaf.text : `//${leaf.text}`, "_blank");
        }}
      >
        <u>{children}</u>
      </a>
    );
  }
  if (leaf.decoration === "email") {
    children = (
      <a
        href={`mailto:${leaf.text}`}
        onClick={(e: MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          window.open(`mailto:${leaf.text}`, "_blank");
        }}
        {...attributes}
      >
        <u>{children}</u>
      </a>
    );
  }

  if (leaf.decoration === "phone") {
    const parsedPhoneNumber = parsePhoneNumber(leaf.text);
    const phoneNumberLink = parsedPhoneNumber?.link;
    if (phoneNumberLink) {
      children = (
        <a
          href={phoneNumberLink!}
          onClick={(e: MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            window.open(phoneNumberLink!, "_blank");
          }}
          {...attributes}
        >
          <u>{children}</u>
        </a>
      );
    }
  }

  return <span {...attributes}>{children}</span>;
};

export default displayElements;
